import React from 'react';
import { NombreEquipoCategoria } from '../funciones/FuncionesEquipo.js';
import styles from './FichaCuadroResultado.module.css';
import LinkPlus from '../UI/LinkPlus.js';

const FichaCuadroResultado = (props) => {
  const partido = props.partido;

  return (
    <React.Fragment>
      <div className={`${styles.resultadoPartido}`}>
        <div className={`${styles.filaResultado}`}>
          <div className={`${styles.nombreEquipo}`}>
            <LinkPlus
              className={`${styles.linkEquipo}`}
              to={'/equipo/' + partido.equipoLocal.id}
              adaptativo={true}
            >
              {partido.equipoLocal &&
                NombreEquipoCategoria(
                  partido.equipoLocal.nombre,
                  partido.equipoLocal.categoria,
                  partido.categoria
                )}
            </LinkPlus>
          </div>
          <div className={`${styles.resultadoEquipo}`}>{partido.resultadoLocal}</div>
          <span className={styles.separadorResultado}>-</span>
          <div className={`${styles.resultadoEquipo}`}>{partido.resultadoVisitante}</div>
          <div className={`${styles.nombreEquipo}`}>
            <LinkPlus
              className={`${styles.linkEquipo}`}
              to={'/equipo/' + partido.equipoVisitante.id}
              adaptativo={true}
            >
              {partido.equipoVisitante &&
                NombreEquipoCategoria(
                  partido.equipoVisitante.nombre,
                  partido.equipoVisitante.categoria,
                  partido.categoria
                )}
            </LinkPlus>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FichaCuadroResultado;
